import { render } from "./EmptyView.vue?vue&type=template&id=8f4c9c34"
import script from "./EmptyView.vue?vue&type=script&lang=js"
export * from "./EmptyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__